// extracted by mini-css-extract-plugin
export default {"container":"QuoteFilterPanelCheckboxSection_container__DpIUV","checkboxesContainer":"QuoteFilterPanelCheckboxSection_checkboxesContainer__isUN9"};